// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board($id: uuid!, $user_id: uuid!) {
  tasks_boards_by_pk(id: $id) {
    id
    name
    metadata
    type
    created_by
    stages {
      id
      text: name
      order
      done
      tasks_aggregate {
        aggregate {
          count
        }
      }
      subscribers(where: { user_id: { _eq: $user_id } }) {
        id
      }
    }
  }
}

`